import React from "react"
import { Badge } from "react-bootstrap"

export type FleetBadgeProps = {
  fleetName: string
  className?: string
}

/**
 * Badge-Komponente für Flottennamen
 */
export const FleetBadge: React.FC<FleetBadgeProps> = ({ fleetName, className }) => {
  return (
    <Badge bg="secondary" className={className}>
      {fleetName}
    </Badge>
  )
}
